import { ComponentPropsWithRef, forwardRef, ForwardRefRenderFunction, ReactNode } from 'react'

import styles from './CheckboxToggleInput.module.css'

export type CheckboxToggleInputProps = (
  | {
      label?: never
      children: ReactNode
    }
  | {
      label: string
      children?: never
    }
) & { inputClassName?: string } & Omit<ComponentPropsWithRef<'input'>, 'type'>

export const CheckboxToggleInputRender: ForwardRefRenderFunction<
  HTMLInputElement,
  CheckboxToggleInputProps
> = (
  {
    label,
    children,
    className = '',
    inputClassName = '',
    disabled,
    ...inputProps
  }: CheckboxToggleInputProps,
  ref,
) => {
  return (
    <label
      className={[styles.toggleContainer, disabled ? styles.disabled : null, className].join(' ')}
    >
      <input
        type="checkbox"
        ref={ref}
        disabled={disabled}
        {...inputProps}
        className={[styles.toggleInput, inputClassName].join(' ')}
      />
      <span className={styles.toggleBlock}>
        <span className={styles.toggleChip} />
      </span>
      {children ?? label}
    </label>
  )
}

export const CheckboxToggle = ({
  onChange,
  disabled,
  ...inputProps
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  disabled?: boolean
}) => {
  return (
    <label className={[styles.toggleContainer, disabled ? styles.disabled : null].join(' ')}>
      <input type="checkbox" onChange={onChange} disabled={disabled} className={[styles.toggleInput].join(' ')} {...inputProps} />
      <span className={styles.toggleBlock}>
        <span className={styles.toggleChip} />
      </span>
    </label>
  )
}

export const CheckboxToggleInput = forwardRef(CheckboxToggleInputRender)
